import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { UsefulWebsite } from '../../models/useful-website';
import { NgForm, NgControl } from '@angular/forms';

@Component({
  selector: 'app-useful-website',
  templateUrl: './useful-website.component.html',
  styleUrls: ['./useful-website.component.css']
})
export class UsefulWebsiteComponent implements OnInit {

  // ** Useful website that represents the content for this control */
  @Input() usefulWebsite: UsefulWebsite;
  usefulWebsiteUndo: UsefulWebsite = new UsefulWebsite();

  // ** Indicates if we are editing or viewing this particular instance */
  @Input() edit = false;

  /** Event emitters */
  @Output() update: EventEmitter<UsefulWebsite> = new EventEmitter();
  @Output() delete: EventEmitter<UsefulWebsite> = new EventEmitter();
  @Output() cancel: EventEmitter<null> = new EventEmitter();

  form: NgForm;
  cancelGlobalEscape = false;

  constructor() { }

  ngOnInit() {
    this.readyUndo();
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.undo();
  }

  cardClick(event: MouseEvent) {
    if (!this.edit) {
      this.edit = true;
    }
  }

  // Stop bubbling events freing other events we don't need to happen
  cancelBubble(event: MouseEvent) {
    event.stopPropagation();
  }

  private undo() {
    Object.assign(this.usefulWebsite, this.usefulWebsiteUndo);
    this.edit = false;
    this.cancel.emit(null);
  }

  readyUndo() {
    // Clone the data object to undo
    Object.assign(this.usefulWebsiteUndo, this.usefulWebsite);
  }

  updateSite(event: MouseEvent) {
    this.update.emit(this.usefulWebsite);
    this.cancelBubble(event);
    this.edit = false;
  }

  deleteSite(event: MouseEvent) {
    this.delete.emit(this.usefulWebsite);
    this.cancelBubble(event);
    this.edit = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/useful-website/useful-website.component.ts